import userModel from '../../../../models/user/user.model';
import ViewBase from '../../../view-base.view';

export default function UserDetailsInfoView() {
  ViewBase.call(this);

  var _userInfo = {};

  let getUserDetails = (encryptedUserId) => {
    this.showLoading();
    userModel.getUserDetails(
      (result) => {
        this.hideLoading();
        _userInfo = result?.data ?? {};
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      encryptedUserId);
  }

  let renderLabel = (label, value) => {
    return [m('label.col-sm-4 .form-label', label), m('span.col-sm-8 .highlight-gray font-weight-bold', value)];
  }

  return {
    oninit: (vnode) => {
      getUserDetails(vnode.attrs.encryptedUserId);
    },
    view: (vnode) => {
      return [
        m('.card.mb-3.searchbox',
          m(".card-body.py-4",
            m('.row.justify-content-center',
              m('.col-md-12',
                m('form',
                  m('.row.mb-3', m('h3', 'General Information')),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000049", "User ID"), _userInfo.userID)),
                    m('.col-md-6', renderLabel(this.getText("LT00000050", "User Name"), _userInfo.userName)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000191", "Mobile Number"), _userInfo.mobileNumber)),
                    m('.col-md-6', renderLabel(this.getText("LT00000190", "Email"), _userInfo.email)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000188", "Country"), _userInfo.countryName)),
                    m('.col-md-6', renderLabel(this.getText("LT00000060", "User Role"), _userInfo.userRoleName)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000015", "Status"), _userInfo.statusName)),
                    m('.col-md-6', renderLabel(this.getText("LT00000195", "Language"), _userInfo.languageName)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000268", "Last Access"), _userInfo.lastAccessDateTimeFormat)),
                    m('.col-md-6', renderLabel(this.getText("LT00000269", "Last Change Password"), _userInfo.lastChangePasswdDateTimeFormat)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000270", "Sales Force"), !!_userInfo?.salesForceYN && (_userInfo.salesForceYN == "Y" ? "Yes" : "No"))),
                    m('.col-md-6', renderLabel(this.getText("LT00000192", "Sales Force Type"), _userInfo.salesForceTypeName)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000194", "Sales Force Rank Type"), _userInfo.salesForceRankTypeName)),
                    m('.col-md-6', renderLabel(this.getText("LT00000193", "User Type"), _userInfo.userTypeName)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000271", "Supervisor"), _userInfo.supervisorName)),
                    m('.col-md-6', renderLabel(this.getText("LT00000249", "User Grade"), _userInfo.userGradeName)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000272", "Is Promoter"), !!_userInfo?.isPromoterYN && (_userInfo.isPromoterYN == "N" ? "No" : "Yes"))),
                    m('.col-md-6', renderLabel(this.getText("LT00000258", "Additional Info"), _userInfo.additionalInfo)),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000711", "Face Recognition"), !!_userInfo?.faceRecognitionYN && (_userInfo.faceRecognitionYN == "N" ? "No" : "Yes")))
                  ]
                  ),
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
